import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import { Entity } from '../select-list/select-list.component';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-regions',
  templateUrl: './regions.component.html',
  styleUrls: ['./regions.component.css']
})
export class RegionsComponent implements OnInit {
  public title : string;
  constructor(public api : ApiService) {
  }

  ngOnInit() {
  }

  get items(){
    return this.api.session.currentCriteria.regions.selectedCategory.children;
  }

  get selectedItems() {
    return this.api.session.currentCriteria.regions.selectedItems;
  }
  set selectedItems(value){
    MyUtility.scrubChildren(value);
    console.log("setting selected regions to " + JSON.stringify(value));
    this.api.session.currentCriteria.regions.selectedItems = value;
  }

  clearCurrent(){
    this.selectedItems = [];
    this.api.session.currentCriteria.regions.groupName = "";
  }
}
